import { render, staticRenderFns } from "./Ventilation.vue?vue&type=template&id=03231768&"
import script from "./Ventilation.vue?vue&type=script&lang=ts&"
export * from "./Ventilation.vue?vue&type=script&lang=ts&"
import style0 from "./Ventilation.vue?vue&type=style&index=0&id=03231768&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports